import { call, put, takeLatest } from "redux-saga/effects";
import { httpCreateQuestion } from "../../../services/questions";
import {
  createQuestionStart,
  createQuestionSuccess,
  createQuestionsFailure,
} from "../reducer";
import { successNotifier } from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* handleCreate({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpCreateQuestion, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(createQuestionSuccess(raw));
    successNotifier("Question added successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createQuestionsFailure(message || raw?.error));
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onCreateQuestion() {
  yield takeLatest(createQuestionStart.type, handleCreate);
}
